/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportConnectionTagsSmsDefinition$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected sms configuration
 */
  smsUid: string;
}

export function exportConnectionTagsSmsDefinition(http: HttpClient, rootUrl: string, params: ExportConnectionTagsSmsDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportConnectionTagsSmsDefinition.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('smsUid', params.smsUid, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.ms-excel', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportConnectionTagsSmsDefinition.PATH = '/stations/{uid}/sms/configuration/{smsUid}/export';
